exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sign-up-form{\r\n  background: white;\r\n}\r\n\r\n.sign-up-form .little-gap{\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.sign-up-form label{\r\n  padding-top: 5px;\r\n}\r\n\r\n.sign-up-form .btn {\r\n    padding: 3px;\r\n    margin: 10px;\r\n}\r\n\r\n.feedback{\r\n    margin:10px;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/signup/signup.component.css
// module id = 1049
// module chunks = 0